import { render, staticRenderFns } from "./MainAccountBank.vue?vue&type=template&id=4b747070"
import script from "./MainAccountBank.vue?vue&type=script&lang=js"
export * from "./MainAccountBank.vue?vue&type=script&lang=js"
import style0 from "./MainAccountBank.vue?vue&type=style&index=0&id=4b747070&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports